"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var validator_1 = require("@formily/validator");
var shared_1 = require("@formily/shared");
var numberRE = /^\d+$/;
var findProperty = function (object, propertyKey) {
    if (!object)
        return object;
    if (object[propertyKey]) {
        return object[propertyKey];
    }
    for (var key in object) {
        if (shared_1.FormPath.parse(key).match("[[" + propertyKey + "]]")) {
            return object[key];
        }
    }
};
var filterProperties = function (object, keys) {
    var result = {};
    for (var key in object) {
        if (!keys.includes(key) && Object.hasOwnProperty.call(object, key)) {
            result[key] = object[key];
        }
    }
    return result;
};
var COMPAT_FORM_ITEM_PROPS = [
    'required',
    'prefix',
    'labelAlign',
    'hasFeedback',
    'labelCol',
    'wrapperCol',
    'label',
    'help',
    'labelTextAlign',
    'fullWidth',
    'extra',
    'size',
    'asterisk',
    'labelWidth',
    'device',
    'isPreview',
    'renderPreview',
    'validateState',
    'colon',
    'htmlFor',
    'validateStatus',
    'prefixCls',
    'triggerType',
    'itemStyle',
    'itemClassName',
    'addonAfter'
];
var Schema = (function () {
    function Schema(json, parent, key) {
        this._isJSONSchemaObject = true;
        if (parent) {
            this.parent = parent;
        }
        if (key) {
            this.key = key;
        }
        if (this.parent && this.parent.isArray()) {
            this.path = this.parent.path + '.*';
        }
        else {
            if (this.parent) {
                this.path = this.parent.path
                    ? this.parent.path + '.' + this.key
                    : this.key;
            }
            else {
                this.path = '';
            }
        }
        return this.fromJSON(json);
    }
    Schema.prototype.get = function (path) {
        if (!path) {
            return this;
        }
        var res = this;
        var depth = 0;
        var parsed = shared_1.FormPath.parse(path);
        parsed.forEach(function (key) {
            if (res && !shared_1.isEmpty(res.properties)) {
                res =
                    findProperty(res.properties, key) ||
                        findProperty(res.properties, parsed.segments.slice(depth).join('.'));
            }
            else if (res && !shared_1.isEmpty(res.items) && numberRE.test(key)) {
                res = shared_1.isArr(res.items) ? findProperty(res.items, key) : res.items;
            }
            depth++;
        });
        return res;
    };
    Schema.prototype.merge = function (spec) {
        if (spec instanceof Schema) {
            Object.assign(this, spec.getSelfProps());
        }
        else {
            Object.assign(this, spec);
        }
        return this;
    };
    Schema.prototype.getEmptyValue = function () {
        if (this.type === 'string') {
            return '';
        }
        if (this.type === 'array') {
            return [];
        }
        if (this.type === 'object') {
            return {};
        }
        if (this.type === 'number') {
            return 0;
        }
    };
    Schema.prototype.getSelfProps = function () {
        var _a = this, _isJSONSchemaObject = _a._isJSONSchemaObject, properties = _a.properties, additionalProperties = _a.additionalProperties, additionalItems = _a.additionalItems, patternProperties = _a.patternProperties, items = _a.items, path = _a.path, parent = _a.parent, props = __rest(_a, ["_isJSONSchemaObject", "properties", "additionalProperties", "additionalItems", "patternProperties", "items", "path", "parent"]);
        return props;
    };
    Schema.prototype.getExtendsRules = function () {
        var _this = this;
        var rules = [];
        if (this.format) {
            rules.push({ format: this.format });
        }
        if (shared_1.isValid(this.maxItems)) {
            rules.push({ max: this.maxItems });
        }
        if (shared_1.isValid(this.minItems)) {
            rules.push({ min: this.minItems });
        }
        if (shared_1.isValid(this.maxLength)) {
            rules.push({ max: this.maxLength });
        }
        if (shared_1.isValid(this.minLength)) {
            rules.push({ min: this.minLength });
        }
        if (shared_1.isValid(this.maximum)) {
            rules.push({ maximum: this.maximum });
        }
        if (shared_1.isValid(this.minimum)) {
            rules.push({ minimum: this.minimum });
        }
        if (shared_1.isValid(this.exclusiveMaximum)) {
            rules.push({ exclusiveMaximum: this.exclusiveMaximum });
        }
        if (shared_1.isValid(this.exclusiveMinimum)) {
            rules.push({ exclusiveMinimum: this.exclusiveMinimum });
        }
        if (shared_1.isValid(this.pattern)) {
            rules.push({ pattern: this.pattern });
        }
        if (shared_1.isValid(this.const)) {
            rules.push({
                validator: function (value) {
                    return value === _this.const ? '' : validator_1.getMessage('schema.const');
                }
            });
        }
        if (shared_1.isValid(this.multipleOf)) {
            rules.push({
                validator: function (value) {
                    return value % _this.multipleOf === 0
                        ? ''
                        : validator_1.getMessage('schema.multipleOf');
                }
            });
        }
        if (shared_1.isValid(this.maxProperties)) {
            rules.push({
                validator: function (value) {
                    return Object.keys(value || {}).length <= _this.maxProperties
                        ? ''
                        : validator_1.getMessage('schema.maxProperties');
                }
            });
        }
        if (shared_1.isValid(this.minProperties)) {
            rules.push({
                validator: function (value) {
                    return Object.keys(value || {}).length >= _this.minProperties
                        ? ''
                        : validator_1.getMessage('schema.minProperties');
                }
            });
        }
        if (shared_1.isValid(this.uniqueItems) && this.uniqueItems) {
            rules.push({
                validator: function (value) {
                    value = shared_1.toArr(value);
                    return value.some(function (item, index) {
                        for (var start = index; start < value.length; start++) {
                            if (shared_1.isEqual(value[start], item)) {
                                return false;
                            }
                        }
                    })
                        ? validator_1.getMessage('schema.uniqueItems')
                        : '';
                }
            });
        }
        if (shared_1.isValid(this['x-rules'])) {
            rules = rules.concat(this['x-rules']);
        }
        return rules;
    };
    Schema.prototype.getExtendsRequired = function () {
        var _a, _b;
        if (shared_1.isBool(this.required)) {
            return this.required;
        }
        else if (shared_1.isArr((_a = this.parent) === null || _a === void 0 ? void 0 : _a.required) && ((_b = this.parent) === null || _b === void 0 ? void 0 : _b.required.includes(this.key))) {
            return true;
        }
    };
    Schema.prototype.getExtendsEditable = function () {
        var editable = this.getExtendsComponentProps().editable;
        if (shared_1.isValid(this.editable)) {
            return this.editable;
        }
        else if (shared_1.isValid(editable)) {
            return editable;
        }
        else if (shared_1.isValid(this.readOnly)) {
            return !this.readOnly;
        }
    };
    Schema.prototype.getExtendsVisible = function () {
        var visible = this.getExtendsComponentProps().visible;
        if (shared_1.isValid(this.visible)) {
            return this.visible;
        }
        else if (shared_1.isValid(visible)) {
            return visible;
        }
    };
    Schema.prototype.getExtendsDisplay = function () {
        var display = this.getExtendsComponentProps().display;
        if (shared_1.isValid(this.display)) {
            return this.display;
        }
        else if (shared_1.isValid(display)) {
            return display;
        }
    };
    Schema.prototype.getMegaLayoutProps = function () {
        return this['x-mega-props'] || this.getExtendsComponentProps()['mega-props'] || {};
    };
    Schema.prototype.getExtendsTriggerType = function () {
        var itemProps = this.getExtendsItemProps();
        var props = this.getExtendsProps();
        var componentProps = this.getExtendsComponentProps();
        if (this.triggerType) {
            return this.triggerType;
        }
        if (itemProps.triggerType) {
            return itemProps.triggerType;
        }
        else if (props.triggerType) {
            return props.triggerType;
        }
        else if (componentProps.triggerType) {
            return componentProps.triggerType;
        }
    };
    Schema.prototype.getExtendsItemProps = function () {
        if (shared_1.isValid(this['x-item-props'])) {
            shared_1.deprecate('x-item-props is deprecate in future, Please do not use it.');
        }
        return this['x-item-props'] || {};
    };
    Schema.prototype.getExtendsComponent = function () {
        return this['x-component'];
    };
    Schema.prototype.getExtendsRenderer = function () {
        if (shared_1.isValid(this['x-render'])) {
            shared_1.deprecate('x-render is deprecate in future, Please do not use it.');
        }
        return this['x-render'];
    };
    Schema.prototype.getExtendsEffect = function () {
        return this['x-effect'];
    };
    Schema.prototype.getExtendsProps = function () {
        return this['x-props'] || {};
    };
    Schema.prototype.getExtendsComponentProps = function () {
        return __assign(__assign({}, filterProperties(this['x-props'], COMPAT_FORM_ITEM_PROPS)), this['x-component-props']);
    };
    Schema.prototype.getExtendsLinkages = function () {
        return this['x-linkages'];
    };
    Schema.prototype.setProperty = function (key, schema) {
        this.properties = this.properties || {};
        this.properties[key] = new Schema(schema, this, key);
        return this.properties[key];
    };
    Schema.prototype.setProperties = function (properties) {
        var _this = this;
        shared_1.each(properties, function (schema, key) {
            _this.setProperty(key, schema);
        });
        return this.properties;
    };
    Schema.prototype.setArrayItems = function (schema) {
        this.items = new Schema(schema, this);
        return this.items;
    };
    Schema.prototype.toJSON = function () {
        var result = this.getSelfProps();
        if (shared_1.isValid(this.properties)) {
            result.properties = shared_1.map(this.properties, function (schema) {
                return schema.toJSON();
            });
        }
        if (shared_1.isValid(this.items)) {
            result.items = shared_1.isArr(this.items)
                ? this.items.map(function (schema) { return schema.toJSON(); })
                : this.items.toJSON();
        }
        if (shared_1.isValid(this.additionalItems)) {
            result.additionalItems = this.additionalItems.toJSON();
        }
        if (shared_1.isValid(this.additionalProperties)) {
            result.additionalProperties = this.additionalProperties.toJSON();
        }
        if (shared_1.isValid(this.patternProperties)) {
            result.patternProperties = shared_1.map(this.patternProperties, function (schema) {
                return schema.toJSON();
            });
        }
        return result;
    };
    Schema.prototype.fromJSON = function (json) {
        var _this = this;
        if (json === void 0) { json = {}; }
        if (typeof json === 'boolean')
            return json;
        if (json instanceof Schema) {
            Object.assign(this, json);
            return this;
        }
        else {
            Object.assign(this, json);
        }
        if (shared_1.isValid(json.type)) {
            this.type = shared_1.lowercase(String(json.type));
        }
        if (shared_1.isValid(json['x-component'])) {
            this['x-component'] = shared_1.lowercase(json['x-component']);
        }
        if (!shared_1.isEmpty(json.properties)) {
            this.properties = shared_1.map(json.properties, function (item, key) {
                return new Schema(item, _this, key);
            });
            if (shared_1.isValid(json.additionalProperties)) {
                this.additionalProperties = new Schema(json.additionalProperties, this);
            }
            if (shared_1.isValid(json.patternProperties)) {
                this.patternProperties = shared_1.map(json.patternProperties, function (item, key) {
                    return new Schema(item, _this, key);
                });
            }
        }
        else if (!shared_1.isEmpty(json.items)) {
            this.items = shared_1.isArr(json.items)
                ? shared_1.map(json.items, function (item) { return new Schema(item, _this); })
                : new Schema(json.items);
            if (shared_1.isValid(json.additionalItems)) {
                this.additionalItems = new Schema(json.additionalItems, this);
            }
        }
        return this;
    };
    Schema.prototype.isObject = function () {
        return this.type === 'object';
    };
    Schema.prototype.isArray = function () {
        return this.type === 'array';
    };
    Schema.prototype.mapProperties = function (callback) {
        return this.getOrderProperties().map(function (_a) {
            var schema = _a.schema, key = _a.key;
            return callback(schema, key);
        });
    };
    Schema.prototype.getOrderProperties = function () {
        return Schema.getOrderProperties(this);
    };
    Schema.prototype.unrelease_getOrderPatternProperties = function () {
        return Schema.getOrderProperties(this, 'patternProperties');
    };
    Schema.prototype.unrelease_mapPatternProperties = function (callback) {
        return this.unrelease_getOrderPatternProperties().map(function (_a) {
            var schema = _a.schema, key = _a.key;
            return callback(schema, key);
        });
    };
    Schema.getOrderProperties = function (schema, propertiesName) {
        if (schema === void 0) { schema = {}; }
        if (propertiesName === void 0) { propertiesName = 'properties'; }
        var newSchema = new Schema(schema);
        var orderProperties = [];
        var unorderProperties = [];
        shared_1.each(newSchema[propertiesName], function (item, key) {
            var index = item['x-index'];
            if (!isNaN(index)) {
                orderProperties[index] = { schema: item, key: key };
            }
            else {
                unorderProperties.push({ schema: item, key: key });
            }
        });
        return orderProperties.concat(unorderProperties).filter(function (item) { return !!item; });
    };
    return Schema;
}());
exports.Schema = Schema;
